
import { VAlert } from "vuetify/lib";

export default VAlert.extend({});
